module.exports = __webpack_public_path__ + "static/media/2.6e5c1cbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/trolls-girl/heads/2.png
// module id = 69
// module chunks = 0